import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
//import axios from "axios";
import queryString from 'query-string';
import SearchList from '../containers/search/SearchList';
import Footer from '../components/Footer';

class Search extends Component {
  state = {};

  render() {
    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    ////console.log(query)
    const strFind = query.st;
    const g = query.q;
    ////console.log(searchList)
    return (
      <Fragment>
        <SearchList strFind={strFind} g={g} />

        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Search));
